import styled from "styled-components";

//ProductInfo


export const ContainerInfo = styled.div`
    // padding: 14px 177px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    z-index: 9;
    position: relative;

     @media (max-width: 768px) {
        padding: 14px 17px;
    //      margin-top: 0px;
    //      padding:  20px;
     }
`

export const BoxInfo = styled.div`
    display: flex;
    gap: 120px;

    @media (max-width: 768px) {
        display: block;
    }

     @media (max-width: 1024px) {
        gap: 35px;
    }
`

export const ContainerPrincipalAvaliacao = styled.div`
    display: block;

    @media (max-width: 768px) {
        width: 100%;
        overflow-x: auto;
    }

    @media (min-width: 1024px) {
        width: 1000px;
        overflow-x: auto;
    }

    @media (min-width: 1440px) {
        width: 100%;
    }

`

export const SubContainerAvaliacao = styled.div`
    display:flex;
    gap:25px;

    @media (max-width: 768px) {
        width: 100%;
        overflow-x: auto;
        display: flex;
        gap:25px;
    }
`

export const BoxSubInfo = styled.div`
    // width: 506px;
    display: inline-block;
    // border:solid 1px;


    @media (max-width: 1024px) {
        width: 400px;
    }

    @media (max-width: 705px) {
        width: 250px;
    }
`

export const BoxSubInfo2 = styled.div`
    display: block;
    height: 500px;
    max-width: 460px
    // @media (max-width: 768px) {
    //     width: 100%;
    //     // margin:20px;
    // }
`

export const ImgProduct = styled.div`
    display: inline-flex;
    // height: 450px;
    // width: 450px;
    // padding: 10px;
    justify-content: center;
    align-items: center;
    // background: black;

    // @media (max-width: 768px) {
    //     height: auto;
    //     // width: auto;
    // }

    // @media (width: 1024px) {
    //     height: 400px;
    //     width: 400px;
    // }
`

export const SelecaoList = styled.div`
    gap: 10px;
    display: flex;
    margin-top: 15px;
    display: inline-flex;
    width: max-content;
    // border:solid 1px;

`

export const ImgSelecaoProduct = styled.div`
    width: 100px;
    height: 100px;
    background: #D2D2D2;
    cursor: pointer;
    // border: solid 1px;

     @media (max-width: 425px) {
    width: 80px;
    height: 80px;
    }

`

export const NomeProduto = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.2px;
    margin: 0;
    margin-top: 11px;
    margin-bottom: 5px;

    @media (max-width: 768px) {
        mletter-spacing: 0px;
    }
`

export const BoxAvaliacao = styled.div`
    display: flex;
    align-items: center;

`


export const AvaliacaoP = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-left: 10px;
`

export const BoxInfoProduto1 = styled.div`
    border-bottom: 1px solid #D2D2D2;
    padding-bottom: 25px;
`

export const BoxInfoProduto2 = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 25px;
`

export const ValorPrincipal = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.1px;
    margin: 0;
`


export const QuantasVezes = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.1px;
    margin: 0;
`

export const BoxEstoque = styled.div`
    display: flex;
    margin-top: 18px;
`

export const DisponivelP = styled.p`
    margin: 0;
    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
`

export const EstoqueP = styled.p`
    margin: 0;

    color: #D2D2D2;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
    margin-left: 5px;
`

export const DescricaoPrincipal = styled.p`
    margin: 0;

    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.2px;
    margin-top: 21px;
`


export const TamanhoP = styled.p`
    margin: 0;

    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
`

export const BoxTamanhoProduto = styled.div`
    margin: 0;
    display: flex;
    margin-top: 5px;
`

export const TamanhoProduto = styled.div`
    margin: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 6px 10px;
    margin-right: 5px;
    border-radius: 5px;
    background: #D2D2D2;
    // cursor: pointer;
`

export const TP = styled.p`
    margin: 0;

    color: #FFF;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
    
`

export const CorP = styled.p`
    margin: 0;
    margin-top: 10px;
    margin-bottom: 5px;
    color: var(--Cinza-2, #848484);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.2px;
    
`

export const BoxInfoProduto3 = styled.div`
    margin: 0;
    margin-top: 25px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    
`

export const AddCarrinho = styled.button`
    display: flex;
    padding: 10px 20px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border: none;
    border-radius: 20px;
    background: #848484;
    cursor: pointer;
`

export const AddCarrinhoP = styled.p`
    color: #FFF;
    text-align: center;
     white-space: nowrap;

    /* h6 */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const BtnFavorito = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    border-radius: 44.786px;
    border: 1px solid #E8E8E8;
    background: #FFF;
    cursor: pointer;
`

export const BtnCarrinho = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    border-radius: 44.786px;
    border: 1px solid #E8E8E8;
    background: #FFF;
    cursor: pointer;
`

//ProductDescription

export const ContainerDescription = styled.div`
    display: inline-flex;
    padding: 62px 179px 62px 180px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 35px;
    width: 1049px;

    @media (max-width: 768px) {
        padding: 0px;
        display: inline-block;
        width: 100%;
    }

    @media (width: 1024px) {
        padding: 50px 20px 50px 20px;
        width: 96%;
    }
`

export const Description = styled.div`
    display: block;

     @media (max-width: 768px) {
        margin:20px;
    }
`

export const NavDescription = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;

    @media (max-width: 768px) {
        display:block;
    }
`

export const ContainerNavDescription = styled.div`
    display: flex;
    border-bottom: solid 1px #ECECEC;
    padding: 0px 0px 35px;

     @media (max-width: 768px) {
        padding: 0px 0px 20px;
    }
`

export const NavLi = styled.div`
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

export const ContainerDescriptionProd = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 40px;
    margin-top:35px;

    @media (max-width: 768px) {
        display:block;
    }

    @media (max-width: 1024px) {
        gap: 20px;
    }
`


export const ContainerDescriptionProd2 = styled.div`
    display: block;
    // align-items: flex-start;
    // gap: 40px;
    // margin-top:35px;

`

export const ContainerImagenProduto = styled.div`
    padding: 0;
    padding-right: 12px;
    padding-bottom: 10px;
    background-color: rgba(196, 196, 196, 0.20);
    border-radius: 20px;

    @media (max-width: 768px) {
        padding-right: 0px;
        padding-bottom: 0px;
    }
`

export const ImagenDescricao = styled.div`
    width: 316px;
    height: 372px;
    background-color: #848484;
    border-radius: 20px;

    @media (max-width: 768px) {
        width: 100%;
    }

     @media (width: 1024px) {
        width: 250px;
        height: 350px;
    }
`

export const TituloDescricao = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.1px;
    margin:0;
    margin-bottom:30px;

    @media (max-width: 768px) {
        margin-top:40px;
    }

    @media (max-width: 1024px) {
         font-size: 20px;
    }
`
export const PDescricao = styled.p`
    color: #848484;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    margin:0;

    @media (max-width: 768px) {
        margin-bottom:20px;
    }

    @media (max-width: 1024px) {
        font-size: 12px;
    }
`

export const POn = styled.p`
    color: #848484;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    margin:0;
`
export const POff = styled.p`
    color: #D2D2D2;
    text-align: center;

    /* link */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
    letter-spacing: 0.2px;
    margin:0;
    cursor: pointer;
`

export const NomeComprador = styled.p`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.69px;
    margin:0;
    margin-top:10px;
`

export const Pdata = styled.p`
    color: #555;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.69px;
    margin:0;
`

export const SetaCirculo = styled.button`
    display: flex;
    padding: 15px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 50px;
    background: #D2D2D2;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
    border: none;
    cursor: pointer;
`

export const ContainerSetasNav = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 55px;
`